<template>
    <li v-if="!isMobile" class="region-picker">
        <a href="#" @click.stop.prevent="isOpen = !isOpen" class="region-picker--active">
            {{ selectedRegion.name }}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" class="region-picker__arrow">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.28752 0.217681L5.78074 4.49588C5.92113 4.6296 6 4.81093 6 5C6 5.18907 5.92113 5.3704 5.78074 5.50411L1.28752 9.78232C1.21844 9.85042 1.13581 9.90474 1.04444 9.94211C0.953078 9.97948 0.854811 9.99915 0.755377 9.99997C0.655943 10.0008 0.557332 9.98275 0.465298 9.9469C0.373265 9.91105 0.289652 9.8581 0.219339 9.79115C0.149025 9.72421 0.0934196 9.64459 0.0557657 9.55697C0.0181119 9.46934 -0.000835783 9.37544 2.82749e-05 9.28077C0.000892333 9.18609 0.0215508 9.09253 0.0607983 9.00553C0.100046 8.91854 0.157096 8.83986 0.228621 8.77409L4.19164 5L0.228621 1.22591C0.157096 1.16014 0.100046 1.08146 0.0607983 0.994463C0.0215508 0.90747 0.000892333 0.813906 2.82749e-05 0.71923C-0.000835783 0.624554 0.0181119 0.530662 0.0557657 0.443032C0.0934196 0.355403 0.149025 0.275791 0.219339 0.208843C0.289652 0.141894 0.373265 0.0889491 0.465298 0.0530972C0.557332 0.0172452 0.655943 -0.000795788 0.755377 2.69218e-05C0.854811 0.000849632 0.953078 0.0205196 1.04444 0.0578889C1.13581 0.0952583 1.21844 0.149579 1.28752 0.217681V0.217681Z" />
            </svg>
        </a>
        <div class="region-picker__list" :class="{ hide: !isOpen && !isMobile }">
            <a
                class="region-picker__item"
                :class="{'region-picker__item--active': region.id == selectedRegion.id}"
                v-for="region in regions"
                :key="region.id"
                :href="region.link"
                @click.prevent="changeRegion(region)"
            >
                {{ region.name }}
                <span v-if="region.id == selectedRegion.id" class="region-picker__item__dot" />
            </a>
        </div>
    </li>
    <a v-else href="#" class="region-picker--mobile" @click.prevent="">
        Change Region
        <select
            v-model="selectedRegion"
            name="region-picker-select"
            class="region-picker__select"
            @change="redirectToRegion"
            @blur="onBlur"
        >
            <option
                v-for="(region, index) in regions"
                :key="index"
                :href="region.link"
                :value="region"
            >
                {{ region.name }}
            </option>
        </select>
    </a>
</template>

<script>
export default {
    name: "HeaderRegionPicker",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            selectedRegion: {},
            regions: [
                {
                    id: 0,
                    name: "US/CA - USD $",
                    link: "/",
                },
                {
                    id: 1,
                    name: "DE/AT - EUR €",
                    link: "https://www.nzxt.com/de/bld"
                }
            ]
        }
    },
    mounted() {
        this.selectedRegion = this.regions[0];
        this.$nextTick(() => {
            if (!this.isMobile) {
                document.addEventListener("click", () => {
                    this.isOpen = false;
                });
            }
        });
    },
    methods: {
        redirectToRegion() {
            if (this.selectedRegion != this.regions[0]) {
                this.changeRegion(this.selectedRegion);
            }
            this.onBlur();
        },
        onBlur() {
            this.$emit("blured");
        },
        changeRegion(region) {
            const regionCode = region.name.split("/")[0].toUpperCase();
            Cookies.set("SELECTED_REGION", regionCode, { domain: ".nzxt.com" });
            document.location.href = region.link;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.region-picker {
    position: relative !important;

    &--mobile {
        display: flex !important;
        flex-direction: column;
        align-items: center;
    }

    &--active {
        &:hover .region-picker__arrow {
            fill: #FFF;
        }

        &:hover, &:focus {
            color: $oldpurple !important;
        }
    }

    &__list {
        position: absolute;
        display: flex;
        flex-direction: column;
        border: 1px solid #52007A;
        border-radius: 1px;
        background-color: #ffffff;
        bottom: -68px;
        right: 10px;
        z-index: 1;
        min-width: 135px;
    }

    &__arrow {
        fill: $oldpurple;
        height: 8px;
        width: 8px;
        transform: rotate(90deg);
        margin-left: 2px;
        transition: 0.3s ease;
    }

    &__item {
        padding: 8px 15px !important;
        display: flex;
        align-items: center;
        color: #5F707F !important;
        letter-spacing: 1.03px !important;

        &:hover {
            color: #FFF;

            .region-picker__item__dot {
                background: #FFF;
            }
        }

        &__dot {
            background-color: $oldpurple;
            border-radius: 50%;
            right: 11%;
            width: 5px;
            height: 5px;
            transition: 0.3s ease;
            position: absolute;
        }
    }

    &__item--active {
        color: #000 !important;
    }

    &__select {
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position-x: 100%;
        background-position-y: center;
        max-width: fit-content;
        background-color: $purple;
        border: none;
        color: white;
        font-size: 95%;
        padding: 5px 20px;
    }
}
</style>
